<template>
  <div>
    <v-card>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn
              color="primary"
              x-large
              :loading="loading"
              :disabled="loading"
              @click="save"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <!-- <v-card-text> -->
      <!-- <v-row >
        <v-col>
          <v-text-field v-model="config.printer_name" outlined label="Nome da impressora"></v-text-field>
        </v-col>
        <v-col>
            <v-text-field v-model="config.ip_printer_cash" outlined label="IP Impressora caixa"></v-text-field>
        </v-col>
        <v-col>
            <v-text-field v-model="config.ip_printer_kitchen" outlined label="IP Impressora cozinha"></v-text-field>
        </v-col>
      </v-row> -->
      <!-- <v-row >
        <v-col cols="4">
          <v-select v-model="config.ip_printer_network" outlined label="Impressora rede" :items="[{text:'SIM',value:'yes'},{text:'NÃO',value:'not'}]"></v-select>
        </v-col>
      </v-row> -->
      <!-- </v-card-text> -->
    </v-card>

    <!-- Componentes Refatorados -->
    <HotelInfo
      :config="config"
      @update="updateConfig"
      @logo-change="fileLogo"
      @logo-report-change="fileLogoReport"
    />

    <CheckInOutSettings
      :config="config"
      @update="updateConfig"
    />

    <DailyAlertSettings
      :config="config"
      :daily-alert-input="daily_alert_input"
      :daily-alert-interval-input="daily_alert_interval_input"
      @update="updateConfig"
    />

    <AuditAlertSettings
      :config="config"
      :audit-alert-input="audit_alert_input"
      :audit-alert-interval-input="audit_alert_interval_input"
      @update="updateConfig"
    />

    <ConsumptionSettings
      :config="config"
      :consumption-max-input="consumption_max_input"
      @update="updateConfig"
    />

    <RulesSettings
      :config="config"
      @update="updateConfig"
    />

    <div class="printers-hidden">
      <Printers />
    </div>

    <v-card class="mt-6">
      <v-card-title>
        Envio de E-mails
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="12"
            md="4"
          >
            <v-card
              outlined
              class="fill-height"
            >
              <v-card-title class="subtitle-2 font-weight-bold">
                Modo de envio
              </v-card-title>
              <v-card-text>
                <v-radio-group
                  v-model="config.email_integration"
                  column
                >
                  <v-radio
                    label="API HTTP"
                    value="api"
                  ></v-radio>
                  <v-radio
                    label="SMTP"
                    value="smtp"
                  ></v-radio>
                </v-radio-group>
                <div class="text-caption text--secondary">
                  Use API para integrações como Brevo ou SendGrid. Prefira SMTP quando quiser controlar remetentes para cada tipo de aviso.
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="8"
          >
            <v-card
              outlined
              class="fill-height"
            >
              <v-card-title class="subtitle-2 font-weight-bold">
                {{ config.email_integration === 'api' ? 'Credenciais da API' : 'Regras para SMTP' }}
              </v-card-title>
              <v-card-text>
                <template v-if="config.email_integration === 'api'">
                  <v-alert
                    type="info"
                    outlined
                    dense
                    class="mb-4"
                  >
                    Informe o endpoint HTTP e o token de autenticação do provedor (ex.: Brevo). Todos os vouchers usarão essa API.
                  </v-alert>
                  <v-row dense>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="config.url_api"
                        outlined
                        label="URL da API"
                        prepend-icon="mdi-link"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="config.api_key"
                        outlined
                        :type="showApiKey ? 'text' : 'password'"
                        label="API KEY"
                        prepend-icon="mdi-key"
                        :append-icon="showApiKey ? 'mdi-eye-off' : 'mdi-eye'"
                        @click:append="showApiKey = !showApiKey"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <v-alert
                    type="info"
                    outlined
                    dense
                    class="mb-2"
                  >
                    Cadastre credenciais SMTP por contexto (Reservas, Geral, Sistema). O remetente de cada e-mail será definido pelo contexto selecionado no envio.
                  </v-alert>
                  <div class="text-caption text--secondary">
                    Ex.: use <strong>Reservas</strong> para vouchers e confirmações; <strong>Geral</strong> para relatórios administrativos; <strong>Sistema (no-reply)</strong> para senhas e notificações automáticas.
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-slide-y-transition>
          <div v-if="config.email_integration === 'smtp'">
            <v-row
              dense
              class="mt-4"
            >
              <v-col cols="12">
                <v-card
                  outlined
                  :loading="loading_delete_smtp"
                  :disabled="loading_delete_smtp"
                >
                  <v-card-title class="subtitle-2 font-weight-bold">
                    SMTP configurados
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      depressed
                      small
                      @click="openSmtpDialog"
                    >
                      Novo SMTP
                    </v-btn>
                    <v-chip
                      small
                      color="primary"
                      text-color="white"
                      label
                      class="ml-2"
                    >
                      {{ items_smtp.length }} ativo(s)
                    </v-chip>
                  </v-card-title>
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="items_smtp"
                    item-key="id"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.contexts="{ item }">
                      <div class="d-flex flex-wrap">
                        <v-chip
                          v-for="(context, idx) in contextLabels(item.contexts)"
                          :key="idx"
                          x-small
                          class="mr-1 mb-1"
                          :color="context.color"
                          :text-color="context.textColor"
                        >
                          {{ context.label }}
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:item.from_address="{ item }">
                      <div class="text--primary font-weight-medium">
                        {{ item.from_name || '—' }}
                      </div>
                      <div class="text-caption text--secondary">
                        {{ item.from_address || '—' }}
                      </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        color="error"
                        @click="deleteSmtp(item)"
                      >
                        {{ icons.mdiDeleteOutline }}
                      </v-icon>
                    </template>
                    <template v-slot:no-data>
                      Nenhuma configuração cadastrada.
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-slide-y-transition>

        <!-- Botão de Teste de Email -->
        <v-row
          dense
          class="mt-4"
        >
          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="subtitle-2 font-weight-bold">
                <v-icon
                  left
                  color="primary"
                >
                  mdi-email-check
                </v-icon>
                Testar Configuração de E-mail
              </v-card-title>
              <v-card-text>
                <v-alert
                  v-if="!emailConfigured"
                  type="warning"
                  dense
                  text
                  class="mb-3"
                >
                  <div v-if="config.email_integration === 'api'">
                    ⚠️ Configure a <strong>URL da API</strong> e a <strong>API KEY</strong> para habilitar o envio de e-mails.
                  </div>
                  <div v-else>
                    ⚠️ Cadastre ao menos <strong>1 configuração SMTP</strong> válida (com host, porta, usuário e senha) para habilitar o envio de e-mails.
                  </div>
                </v-alert>
                <v-alert
                  v-else
                  type="success"
                  dense
                  text
                  class="mb-3"
                >
                  ✅ Configuração de e-mail válida! Você pode realizar testes e ativar o motor de reservas.
                </v-alert>
                <div class="d-flex align-center">
                  <div class="flex-grow-1 text-body-2 text--secondary">
                    Envie um e-mail de teste para validar se suas configurações estão funcionando corretamente.
                  </div>
                  <v-btn
                    color="primary"
                    outlined
                    :disabled="!emailConfigured"
                    class="test-email-btn"
                    @click="openTestEmailDialog"
                  >
                    <v-icon class="mr-2">
                      mdi-send
                    </v-icon>
                    Enviar Teste
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialogTestEmail"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Enviar E-mail de Teste
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="closeTestEmailDialog"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="testEmail"
            outlined
            label="E-mail de Destino"
            type="email"
            hint="Digite o e-mail onde deseja receber o teste"
            persistent-hint
            prepend-icon="mdi-email"
            :rules="[v => !!v || 'E-mail é obrigatório', v => /.+@.+\..+/.test(v) || 'E-mail inválido']"
          >
          </v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            text
            :disabled="loading_test_email"
            @click="closeTestEmailDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading_test_email"
            :disabled="loading_test_email || !testEmail"
            class="test-email-btn"
            @click="sendTestEmail"
          >
            <v-icon class="mr-2">
              mdi-send
            </v-icon>
            Enviar Teste
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSmtp"
      max-width="720px"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Novo SMTP
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="closeSmtpDialog"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
            v-model="smtp.contexts"
            :items="smtp_contexts"
            item-text="text"
            item-value="value"
            multiple
            chips
            outlined
            label="Contextos atendidos"
            hint="Selecione um ou mais contextos (ex.: Reservas, Geral)"
            persistent-hint
          >
          </v-select>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="smtp.from_name"
                outlined
                label="Nome do remetente"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="smtp.from_address"
                outlined
                label="E-mail do remetente"
                type="email"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="smtp.mailer"
                outlined
                label="Identificador"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="smtp.host"
                outlined
                label="Host"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="smtp.port"
                outlined
                label="Porta"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="smtp.encryption"
                outlined
                label="Criptografia (tls/ssl)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="smtp.username"
                outlined
                label="Usuário"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="smtp.password"
                outlined
                label="Senha"
                type="password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            text
            :disabled="loading_smtp"
            @click="closeSmtpDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading_smtp"
            :disabled="loading_smtp"
            @click="addSmtp"
          >
            Salvar SMTP
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <WhatsAppSettings
      :config="config"
      :whats="whats"
      :show-qr.sync="showQr"
      :loading-qr="loading_qr"
      @update="updateConfig"
      @connect="showModalQr"
      @disconnect="disconnectWhatsApp"
      @refresh-qr="getWhatsQrCode"
    />
  </div>
</template>

<style scoped>
.test-email-btn {
  justify-content: center;
}

.test-email-btn .v-btn__content {
  width: 100%;
  justify-content: center;
}

.printers-hidden {
  display: none !important;
}
</style>

<script>
import { mapActions } from 'vuex'
import {
  mdiPencilOutline, mdiDeleteOutline, mdiPlus, mdiClose,
} from '@mdi/js'
import HotelInfo from './_components/HotelInfo.vue'
import CheckInOutSettings from './_components/CheckInOutSettings.vue'
import DailyAlertSettings from './_components/DailyAlertSettings.vue'
import AuditAlertSettings from './_components/AuditAlertSettings.vue'
import ConsumptionSettings from './_components/ConsumptionSettings.vue'
import RulesSettings from './_components/RulesSettings.vue'
import WhatsAppSettings from './_components/WhatsAppSettings.vue'
import Printers from './_components/Printers.vue'

const SMTP_CONTEXT_COLORS = {
  reserve: { color: 'indigo', textColor: 'white' },
  general: { color: 'teal', textColor: 'white' },
  noreply: { color: '#37474F', textColor: 'white' },
  default: { color: 'secondary', textColor: 'white' },
}

export default {
  components: {
    HotelInfo,
    CheckInOutSettings,
    DailyAlertSettings,
    AuditAlertSettings,
    ConsumptionSettings,
    RulesSettings,
    WhatsAppSettings,
    Printers,
  },
  data: () => ({
    showApiKey: false,
    file: null,
    file_report: null,
    consumption_max_input: {
      error: false,
      message: null,
    },
    daily_alert_input: {
      error: false,
      message: null,
    },
    daily_alert_interval_input: {
      error: false,
      message: null,
    },
    audit_alert_input: {
      error: false,
      message: null,
    },
    audit_alert_interval_input: {
      error: false,
      message: null,
    },
    config: {
      name: null,
      phone: null,
      address: null,
      site: null,
      email: null,
      checkin: null,
      checkout: null,
      url_api: null,
      api_key: null,
      email_integration: 'api',
      consumption_alert: null,
      consumption_max: null,
      daily_alert_enabled: null,
      daily_alert_time: null,
      daily_alert_interval: null,
      audit_alert_enabled: null,
      audit_alert_time: null,
      audit_alert_interval: null,
      whats_endpoint: null,
      whats_key: null,
      whats_instance: null,
      whats_provider: 'evolution',
      whats_greeting: null,
      legal_name: null,
      cnpj: null,
      im: null,
    },
    whats: {
      qr: null,
      number: null,
      connected: false,
    },
    whats_providers: [
      { text: 'Evolution API', value: 'evolution' },
      { text: 'Wuzapi', value: 'wuzapi' },
    ],
    showQr: false,
    dialogSmtp: false,
    dialogTestEmail: false,
    testEmail: '',
    emailConfigured: false,
    loading: false,
    loading_qr: false,
    loading_smtp: false,
    loading_delete_smtp: false,
    loading_test_email: false,
    items_smtp: [],
    smtp: {
      contexts: ['general'],
      from_name: null,
      from_address: null,
      mailer: null,
      host: null,
      port: null,
      username: null,
      password: null,
      encryption: null,
    },
    smtp_default: {
      contexts: ['general'],
      from_name: null,
      from_address: null,
      mailer: null,
      host: null,
      port: null,
      username: null,
      password: null,
      encryption: null,
    },
    smtp_contexts: [
      {
        text: 'Reservas',
        value: 'reserve',
      },
      {
        text: 'Geral',
        value: 'general',
      },
      {
        text: 'Sistema (no-reply)',
        value: 'noreply',
      },
    ],
    smtpContextColors: SMTP_CONTEXT_COLORS,
    headers: [
      {
        text: 'Contextos',
        value: 'contexts',
      },
      {
        text: 'Remetente',
        value: 'from_address',
      },
      {
        text: 'HOST',
        value: 'host',
      },
      {
        text: 'PORT',
        value: 'port',
      },
      {
        text: 'Usuário',
        value: 'username',
      },
      {
        text: 'Criptografia',
        value: 'encryption',
      },
      {
        text: '',
        value: 'actions',
      },
    ],
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
    },
  }),
  created() {
    this.loadConfig().then(response => {
      const data = response.data || {}
      this.config = {
        ...this.config,
        ...data,
        email_integration: data.email_integration || 'smtp',
        whats_provider: data.whats_provider || 'evolution',
      }
      this.items_smtp = (data.smtp || []).map(item => ({
        ...item,
        contexts: item.contexts && item.contexts.length ? item.contexts : ['general'],
      }))
      this.getWhatsStatus()
      this.checkEmailStatus()
    })
  },
  methods: {
    ...mapActions('config', ['storeOrUpdate', 'loadConfig', 'storeSmtp', 'destroySmtp']),
    ...mapActions('whats', ['connect', 'disconnect', 'reconnect', 'getStatus']),
    updateConfig(updates) {
      this.config = { ...this.config, ...updates }
    },
    fileLogo(file) {
      this.file = file
    },
    fileLogoReport(file) {
      this.file_report = file
    },
    save() {
      if (!this.validate()) {
        return
      }

      this.loading = true

      const formData = new FormData()

      formData.append('name', this.config.name)
      formData.append('phone', this.config.phone)
      formData.append('address', this.config.address)
      formData.append('site', this.config.site)
      formData.append('email', this.config.email)
      formData.append('checkin', this.config.checkin)
      formData.append('checkout', this.config.checkout)
      formData.append('url_api', this.config.url_api || '')
      formData.append('api_key', this.config.api_key || '')
      formData.append('consumption_alert', this.config.consumption_alert ? 1 : 0)
      formData.append('consumption_max', this.config.consumption_max)
      formData.append('daily_alert_enabled', this.config.daily_alert_enabled ? 1 : 0)
      formData.append('daily_alert_time', this.config.daily_alert_time)
      formData.append('daily_alert_interval', this.config.daily_alert_interval)
      formData.append('audit_alert_enabled', this.config.audit_alert_enabled ? 1 : 0)
      formData.append('audit_alert_time', this.config.audit_alert_time)
      formData.append('audit_alert_interval', this.config.audit_alert_interval)
      formData.append('email_integration', this.config.email_integration)
      formData.append('whats_endpoint', this.config.whats_endpoint)
      formData.append('whats_key', this.config.whats_key)
      formData.append('whats_instance', this.config.whats_instance)
      formData.append('whats_provider', this.config.whats_provider)
      formData.append('whats_greeting', this.config.whats_greeting)
      formData.append('legal_name', this.config.legal_name)
      formData.append('cnpj', this.config.cnpj)
      formData.append('im', this.config.im)
      formData.append('smoking_rule_enabled', this.config.smoking_rule_enabled ? 1 : 0)
      formData.append('smoking_rule_text', this.config.smoking_rule_text || '')
      formData.append('extra_rule_enabled', this.config.extra_rule_enabled ? 1 : 0)
      formData.append('extra_rule_text', this.config.extra_rule_text || '')

      if (this.file) {
        formData.append('logo', this.file)
      }
      if (this.file_report) {
        formData.append('logo_report', this.file_report)
      }

      this.storeOrUpdate(formData).then(response => {
        this.$toast.success('Salvo com sucesso')
        this.checkEmailStatus()
      }).finally(() => {
        this.loading = false
      })
    },

    validate() {
      if (this.config.consumption_alert == true && this.config.consumption_max == null) {
        this.consumption_max_input.message = 'Campo obrigatório'
        this.consumption_max_input.error = true

        return false
      }
      if (this.config.daily_alert_enabled == true && this.config.daily_alert_time == null) {
        this.daily_alert_input.message = 'Campo obrigatório'
        this.daily_alert_input.error = true

        return false
      }
      if (this.config.daily_alert_enabled == true) {
        if (this.config.daily_alert_interval == null) {
          this.daily_alert_interval_input.message = 'Campo obrigatório'
          this.daily_alert_interval_input.error = true

          return false
        }

        const interval = parseInt(this.config.daily_alert_interval, 10)

        if (!Number.isInteger(interval) || this.config.daily_alert_interval <= 0) {
          this.daily_alert_interval_input.message = 'O intervalo deve ser um número inteiro positivo'
          this.daily_alert_interval_input.error = true

          return false
        }
      }

      if (this.config.audit_alert_enabled == true && this.config.audit_alert_time == null) {
        this.audit_alert_input.message = 'Campo obrigatório'
        this.audit_alert_input.error = true

        return false
      }
      if (this.config.audit_alert_enabled == true) {
        if (this.config.audit_alert_interval == null) {
          this.audit_alert_interval_input.message = 'Campo obrigatório'
          this.audit_alert_interval_input.error = true

          return false
        }

        const interval = parseInt(this.config.audit_alert_interval, 10)

        if (!Number.isInteger(interval) || this.config.audit_alert_interval <= 0) {
          this.audit_alert_interval_input.message = 'O intervalo deve ser um número inteiro positivo'
          this.audit_alert_interval_input.error = true

          return false
        }
      }

      this.daily_alert_input.error = false
      this.daily_alert_input.message = null
      this.daily_alert_interval_input.error = false
      this.daily_alert_interval_input.message = null
      this.audit_alert_input.error = false
      this.audit_alert_input.message = null
      this.audit_alert_interval_input.error = false
      this.audit_alert_interval_input.message = null
      this.consumption_max_input.error = false
      this.consumption_max_input.message = null

      return true
    },
    addSmtp() {
      if (!Array.isArray(this.smtp.contexts) || this.smtp.contexts.length === 0) {
        this.smtp.contexts = ['general']
      }
      this.loading_smtp = true
      this.storeSmtp(this.smtp).then(response => {
        const item = { ...response.data }
        item.contexts = item.contexts && item.contexts.length ? item.contexts : ['general']
        this.items_smtp.push(item)
        this.$toast.success('Configuração SMTP adicionada com sucesso!')
        this.checkEmailStatus()
      }).finally(() => {
        this.loading_smtp = false
        this.resetSmtpForm()
        this.dialogSmtp = false
      })
    },
    deleteSmtp(smtp) {
      this.loading_delete_smtp = true
      const index = this.items_smtp.findIndex(item => item.id === smtp.id)
      this.destroySmtp(smtp).then(response => {
        if (index >= 0) {
          this.items_smtp.splice(index, 1)
        }
        this.$toast.success('Configuração SMTP removida')
        this.checkEmailStatus()
      }).finally(() => {
        this.loading_delete_smtp = false
      })
    },
    resetSmtpForm() {
      this.smtp = { ...this.smtp_default, contexts: ['general'] }
    },
    contextLabels(values) {
      const arr = Array.isArray(values) ? values : [values || 'general']

      return arr.map(value => {
        const ctx = this.smtp_contexts.find(item => item.value === value)
        const label = ctx ? ctx.text : value
        const palette = this.smtpContextColors[value] || this.smtpContextColors.default

        return {
          label,
          color: palette.color,
          textColor: palette.textColor,
        }
      })
    },
    openSmtpDialog() {
      this.dialogSmtp = true
      this.resetSmtpForm()
    },
    closeSmtpDialog() {
      this.dialogSmtp = false
      this.resetSmtpForm()
    },
    async checkEmailStatus() {
      try {
        const response = await this.$http.get('system/config/email-status')
        this.emailConfigured = response.data.configured || false

        // Debug para ajudar a identificar problemas
        if (!this.emailConfigured && response.data.debug) {
          console.log('📧 Status de configuração de email:', response.data.debug)
        }
      } catch (error) {
        console.error('Erro ao verificar status do email:', error)
        this.emailConfigured = false
      }
    },
    openTestEmailDialog() {
      this.testEmail = this.config.email || ''
      this.dialogTestEmail = true
    },
    closeTestEmailDialog() {
      this.dialogTestEmail = false
      this.testEmail = ''
    },
    async sendTestEmail() {
      if (!this.testEmail || !/.+@.+\..+/.test(this.testEmail)) {
        this.$toast.error('Por favor, informe um e-mail válido')

        return
      }

      this.loading_test_email = true
      try {
        const response = await this.$http.post('system/config/test-email', {
          email: this.testEmail,
          context: 'general',
        })

        if (response.data.success) {
          this.$toast.success(response.data.message)
          this.closeTestEmailDialog()
        } else {
          this.$toast.error(response.data.message || 'Erro ao enviar e-mail de teste')
        }
      } catch (error) {
        console.error('Erro ao enviar e-mail de teste:', error)
        const errorMsg = error.response?.data?.message || 'Erro ao enviar e-mail de teste'
        this.$toast.error(errorMsg)
      } finally {
        this.loading_test_email = false
      }
    },

    async getWhatsStatus() {
      const res = await this.getStatus()
      const { data } = res
      this.whats.connected = data.instance.state === 'open'
    },
    async showModalQr() {
      this.loading_qr = true
      const res = await this.connect()

      // transforma a resposta em JSON
      const { data } = res
      this.whats.qr = data.base64
      this.showQr = true
      this.loading_qr = false
    },
    async disconnectWhatsApp() {
      this.loading_qr = true
      const res = await this.disconnect()

      // transforma a resposta em JSON
      const { data } = res
      this.whats.connected = false
      this.$toast.success('Desconectado com sucesso')
      this.whats.qr = null
      this.loading_qr = false
      this.getWhatsStatus()
    },
    async reconnectWhatsApp() {
      this.loading_qr = true
      let res = await this.reconnect()
      res = await this.connect()

      // transforma a resposta em JSON
      const { data } = res
      this.whats.qr = data.base64
      this.showQr = true
      this.loading_qr = false
    },
    async getWhatsQrCode() {
      this.loading_qr = true
      try {
        const res = await this.connect()
        const { data } = res
        this.whats.qr = data.base64
        this.$toast.success('QR Code atualizado')
      } catch (error) {
        this.$toast.error('Erro ao atualizar QR Code')
      } finally {
        this.loading_qr = false
      }
    },

  },
  watch: {
    showQr(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        // significa que o modal acabou de ser fechado
        this.getWhatsStatus() // Atualiza o status do WhatsApp
      }
    },
  },

}
</script>
